module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black_w_0-16e8212a0f9c3e980bdbb968c342f898.svg";